import 'core-js/proposals/reflect-metadata';
import 'zone.js';

import { NgZone }                 from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UIRouter, UrlService }   from '@uirouter/core';

/**
 * ------------------------------
 * CSS Vendor Imports
 * ------------------------------
 */
import 'font-awesome/css/font-awesome.css';
import 'bootstrap-legacy/dist/css/bootstrap.min.css';

import '../vendor/bootstrap-datetimepicker/bootstrap-datetimepicker.css';
import '../vendor/jquery-ui/jquery-ui-1.10.3.custom.css';
import '../vendor/fullcalendar/fullcalendar.min.css';
import '../vendor/color-picker/color-picker.min.css';
import '../vendor/chosen/chosen.min.css';

import '../vendor/simpliq-theme/style.custom.css';

import '../styles/components/_flaticons.css';

/**
 * ------------------------------
 * CSS Custom Imports
 * ------------------------------
 */
import '../styles/main.css';
import '../styles/components/_attachments.css';
import '../styles/components/_autocompletes.css';
import '../styles/components/_buttons.css';
import '../styles/components/_colors.css';
import '../styles/components/_dealership.css';
import '../styles/components/_grids.css';
import '../styles/components/_integrations.css';
import '../styles/components/_overwrites.css';
import '../styles/components/_spacing.css';
import '../styles/components/_stats.css';
import '../styles/components/_vehicle-visuals.css';

import '../styles/scss/app-lite/shared.scss';

import './ajs.module';

import { AppModule } from './app.module';

platformBrowserDynamic().bootstrapModule(AppModule)
.then(( platformRef ) => {
  // Initialize the Angular Module
  // get() the UIRouter instance from DI to initialize the router
  const urlService: UrlService = platformRef.injector.get(UIRouter).urlService;

  // Instruct UIRouter to listen to URL changes
  function startUIRouter() {
    urlService.listen();
    urlService.sync();
  }

  platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);
});